import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, utils_tool, component_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizNotice, WizBrowserExport } = component_tool;
let { checkStrLength, toChinesNum,Session } = utils_tool;
class SeriesProgram extends WizContainer {
  componentName = 'seriesProgram';

  constructor(props) {
    super(props);
    this.state = {
      type: props['type'],
      parent: props['parent']
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleLIST(nextProps, nextState, key) {
    let o = nextProps[key]
    let filterId;
    if (Session.get('seriesRecord')){
      let seriesRecord = Session.get('seriesRecord');
      filterId = seriesRecord.categoryId+'';
    }
    if (o['success']) {
      let records = o.data.records;
      let parentName = '';
      if (Session.get('seriesRecord')){
        let seriesRecord = Session.get('seriesRecord');
        parentName = seriesRecord.name+'>';
      }
      
      records.forEach(d => {
        if (d['parentId'] == filterId) {
          d['parentId'] = undefined;
          d['parentName'] = undefined;
        }
        if (d['parentName'] && d['parentName'].indexOf(parentName)!=-1) {
          d['parentName'] = d['parentName'].replace(parentName,'');
        }
      });
       return true;
    } 
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
    ]
    if (o['success']) {
      let dataList = Object.assign([], o['data'])
      if (dataList && dataList instanceof Array) {
        let maxCategoryLevel = 0;
        dataList.forEach(data => {
          data['parentName'].split('>').forEach((p, index) => {
            if (index > maxCategoryLevel) {
              maxCategoryLevel = index
            }
            data[`category${index}`] = p
          })
        })
        for (let index = 0; index <= maxCategoryLevel; index++) {
          columnDefs.push(
            {
              headerName: `${toChinesNum(index + 1)}级分类`,
              field: `category${index}`,
              width: 30,
              cellStyle: {
                textAlign: 'center',
              },
              style: {
                alignment: { vertical: 'bottom', horizontal: 'left' },
              },
            })

        }
        columnDefs.push({
          headerName: `简介`,
          field: `intro`,
          width: 30,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        })
        if (nextProps['type'] === '2') {
          columnDefs.push({
            headerName: `管理权限`,
            field: `targetScope`,
            width: 100,
            cellStyle: {
              padding: "5px 0",
            },
            style: {
              alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
            },
          })
        }
      }
      WizBrowserExport({
        title: '分类信息',
        sheetName: '分类信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataList,
        filename: '分类信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _handleTreeData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 20
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['title'] = checkStrLength(val['title'], len);
          if (val['children'] && val['children'].length > 0) {
            f(val['children'])
          }
        });
      }
      f(o['data'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let { type ,parent} = this.props
    let record = this.props.location.record;
    let filterId = '';
    let id = '';
    if (record) {
      Session.set('seriesRecord',record);
    }
    if (Session.get('seriesRecord')){
      let seriesRecord = Session.get('seriesRecord');
      filterId = seriesRecord.categoryId;
      id = filterId;
    }
    let _reduxTemplateCofig = reduxTemplateCofig({
      type,parent,filterId,id,
      templateConfig: templateConfig({ type,parent, pathname: this.props.location.pathname }),
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD,
        treeData: this._handleTreeData,
        list:this._handleLIST,
        export: this._handleFile,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const pathList = ownProps.location.pathname.split('/')
  const categoryType = pathList[pathList.length - 1]
  let typeObj = {
    // examination: '0',
    // program: '1',
    // question: '2',
    // offlineTrain: '3',
    // applicationColumn: '4',
    // content:'5',
    // label:'6',
    // series:'7',
    seriesProgram:'8'
  }
  let typeParent = {
    applicationColumn : 'no',
    series : 'no',
  }
  const type = typeObj[categoryType]
  const parent = typeParent[categoryType]
  return { type: type,parent:parent }
};

export default connect(mapStateToProps)(SeriesProgram);
